export default __webpack_public_path__ + "static/MediaContentNine-f7766adc79ef83e9963e0b9b11e89e70.webp";